module.exports = __webpack_public_path__ + "static/novacair-149ca99468d8ea5471b2dc6fe55fad7c.png";